// extracted by mini-css-extract-plugin
export var chevronIcon = "_cy-2";
export var teamName = "_cy-1";
export var teamSwitcherButton = "_cy-0";